import React from "react";
import Hexagon from "../common/Hexagon";
import DiagonalCard from "../common/DiagonalCard";

/**
 * Tarjeta de KPI del tablero.
 *
 * `variant`:
 *   undefined  escritorio — hexágono de 44px arriba a la derecha
 *   'hero'     móvil, la cifra que manda — dentro de un DiagonalCard
 *   'mini'     móvil, las otras cuatro — icono en línea, rejilla 2×2
 */
const DashboardStatCard = ({
    title,
    subtitle,
    value,
    growth,
    growthLabel,
    // Período exacto contra el que se comparó. Va como tooltip de la etiqueta:
    // la tarjeta dice "vs mes anterior", y al pasar el mouse se ven las fechas.
    growthTitle,
    // Texto a mostrar en lugar de la variación cuando la tarjeta todavía no
    // tiene fuente de datos. Sin esto, una tarjeta sin endpoint decía
    // "Sin período anterior para comparar", que da a entender que el valor sí
    // se midió y sólo falta con qué compararlo.
    pendingNote,
    icon,
    color = "#4B36F0",
    // La cifra ES el indicador (Crecimiento de Red): se pinta en el color del
    // hexágono, no en tinta, y no lleva variación debajo.
    accentValue = false,
    variant
}) => {

    // Un crecimiento nulo no es cero: significa que no hay período anterior
    // con el cual comparar. Pintarlo como "0%" con flecha verde diría que las
    // ventas quedaron iguales, que es una afirmación distinta.
    const hasGrowth = growth !== null && growth !== undefined && growth !== '';
    const positive = growth >= 0;

    const delta = hasGrowth ? (
        <div
            className={`ui-kpi__delta ui-kpi__delta--${positive ? "up" : "down"}`}
        >
            <i className={positive ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
            {growth}%
            {/*
              La etiqueta va más chica que el porcentaje: lo que importa leer es
              la variación, no contra qué. El rango exacto del período comparado
              queda en el tooltip, para no cargar la tarjeta con fechas.
            */}
            {growthLabel && (
                <span
                    className="ui-kpi__label"
                    title={growthTitle || undefined}
                    style={{ cursor: growthTitle ? "help" : "default" }}
                >
                    {growthLabel}
                </span>
            )}
        </div>
    ) : accentValue ? null : (
        // La cifra ES el indicador en las tarjetas `accentValue` (Crecimiento
        // de Red): no llevan nada debajo del porcentaje.
        <div className="ui-kpi__note">
            {pendingNote || "Sin período anterior para comparar"}
        </div>
    );

    const valueStyle = accentValue ? { color } : undefined;

    if (variant === "mini") {
        return (
            <div className="ui-card ui-kpi ui-kpi--mini">
                <div className="ui-kpi__head">
                    <i className={icon} style={{ color, fontSize: 15 }} />
                    <span>{title}</span>
                </div>
                <div className="ui-kpi__value" style={valueStyle}>{value}</div>
                {delta}
            </div>
        );
    }

    const body = (
        <>
            <div className="ui-kpi__row">
                <div style={{ minWidth: 0 }}>
                    <div className="ui-kpi__title">{title}</div>
                    <div className="ui-kpi__sub">{subtitle}</div>
                </div>
                <Hexagon size={44} color={color} icon={icon} />
            </div>
            <div className="ui-kpi__value" style={valueStyle}>{value}</div>
            {delta}
        </>
    );

    if (variant === "hero") {
        return (
            <DiagonalCard cut={22} className="ui-kpi ui-kpi--hero">
                {body}
            </DiagonalCard>
        );
    }

    return <div className="ui-card ui-kpi">{body}</div>;

};

export default DashboardStatCard;
